
import React from "react";
import { Modal, Box, Typography, TextField, Button, RadioGroup, FormControlLabel, Radio, Autocomplete, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { array, bool, func, string } from "prop-types";

const EditPublicationModel = ({ open, onClose, title, onSave, fields, onFieldChange, regions }) => {

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          height: "80%",
          width: "50%",
          maxHeight: "90vh",
          maxWidth: "90vw",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          overflow: "auto",
        }}
      >
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>

        {/* Loop through the fields and render inputs */}
        {fields?.map((field, index) => {
          // Render TextField for "text" and "number" types
          if (field.type === "text" || field.type === "number") {
            return (
              <TextField
                key={index}
                label={field.label}
                fullWidth
                value={field.value}
                onChange={(e) => onFieldChange(e, field.name)}
                margin="normal"
                type={field.type || "text"}
              />
            );
          }
          if (field.type === "select") {
            return (
              <Box key={index} marginY={2}>

                <FormControl
                  fullWidth
                  key={index}
                  margin="normal"
                  sx={{ mt: 0, minHeight: 50 }} // Reducing upper margin with `mt: 0`
                >
                  <InputLabel sx={{ top: "-5px" }}>{field.label}</InputLabel> {/* Adjust label position if needed */}
                  <Select
                    value={field.value || ""}
                    onChange={(e) => onFieldChange({ target: { value: e.target.value } }, field.name)}
                    sx={{ height: 45, paddingTop: 0, paddingBottom: 0 }} // Reduce internal padding
                  >
                    {/* {field.options?.map((option, optionIndex) => (
                      <MenuItem key={optionIndex} value={option}>
                        {option}
                      </MenuItem>
                    ))} */}
                    <MenuItem value="">None</MenuItem>
                    {regions?.length > 0 ? (
                      regions.map((region) => (
                        <MenuItem key={region.regionId} value={region.region}>
                          {region.region.toUpperCase()}
                        </MenuItem>
                      ))
                    ) : (
                      field.options.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>

              </Box>
            );
          }
          // Handle Multi-select Autocomplete
          if (field.type === "multi-select") {
            return (
              <Box key={index} marginY={2}>

                <Autocomplete
                  multiple
                  options={field.options || []}
                  value={field.value || []}
                  onChange={(event, newValue) => {
                    onFieldChange({ target: { value: newValue } }, field.name, newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={field.label}
                      placeholder={field.placeholder || "Select"}
                      style={{ marginBottom: 16 }}
                    />
                  )}
                />

              </Box>
            );
          }

          // Render RadioGroup for "radio" type
          if (field.type === "radio") {
            return (
              <Box key={index} marginY={2}>
                <Typography variant="body1" gutterBottom>
                  {field.label}
                </Typography>
                <RadioGroup
                  row
                  value={field.value}
                  onChange={(e) => onFieldChange(e, field.name)}
                >
                  {field.options?.map((option, optionIndex) => (
                    <FormControlLabel
                      key={optionIndex}
                      value={option.value}
                      control={<Radio />}
                      label={option.label}
                    />
                  ))}
                </RadioGroup>
              </Box>
            );
          }

          return null; // Handle unknown field types
        })}

        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button variant="contained" color="primary" onClick={onSave} style={{ color: 'white' }}>
            Save
          </Button>
          <Button variant="outlined" color="secondary" onClick={onClose} sx={{ ml: 2, color: "red" }}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

EditPublicationModel.propTypes = {
  open: bool.isRequired,
  onClose: func.isRequired,
  title: string.isRequired,
  onSave: func.isRequired,
  fields: array.isRequired,
  onFieldChange: func.isRequired,
  regions: string.isRequired,
};

export default EditPublicationModel;
